import { queryClient } from './queryClient';
import { queryKeys } from './queryKeys';

/** After video generation completes — credits spent, user data changed, new video exists */
export function invalidateAfterGeneration(supabaseUserId: string) {
  queryClient.invalidateQueries({ queryKey: queryKeys.credits(supabaseUserId) });
  queryClient.invalidateQueries({ queryKey: queryKeys.user(supabaseUserId) });
  queryClient.invalidateQueries({ queryKey: queryKeys.userVideos() });
}

/** After credits are deducted but generation is still in progress — no new video yet */
export function invalidateAfterCreditDeduction(supabaseUserId: string) {
  queryClient.invalidateQueries({ queryKey: queryKeys.credits(supabaseUserId) });
  queryClient.invalidateQueries({ queryKey: queryKeys.user(supabaseUserId) });
}

/** After credit purchase — credits changed, user may have subscription changes */
export function invalidateAfterCreditPurchase() {
  // Partial key matching — invalidates all user/credit queries regardless of userId.
  // Used when userId isn't available (e.g. CreditsSuccessPage).
  queryClient.invalidateQueries({ predicate: (query) => {
    const key = query.queryKey[0];
    return key === 'credits' || key === 'user';
  }});
}

/** After signup — new user record exists */
export function invalidateAfterSignup(supabaseUserId: string) {
  queryClient.invalidateQueries({ queryKey: queryKeys.user(supabaseUserId) });
  queryClient.invalidateQueries({ queryKey: queryKeys.credits(supabaseUserId) });
}
